const IconArrowLeft = ({ fill, className, dataTestid = 'icon-arrow-left' }) => (
  <svg
    data-testid={dataTestid}
    className={className}
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={`${className}-path`}
      data-testid={`${dataTestid}-path`}
      d="M18.2608 10.1617L4.26323 10.1617L8.54747 15.231C8.7478 15.4685 8.84418 15.7746 8.81541 16.082C8.78664 16.3895 8.63507 16.6731 8.39404 16.8704C8.15302 17.0678 7.84229 17.1627 7.5302 17.1344C7.21812 17.106 6.93024 16.9567 6.72991 16.7193L0.828752 9.74314C0.789049 9.68765 0.753546 9.62936 0.72253 9.56874C0.722531 9.5106 0.722531 9.47572 0.639915 9.41759C0.586419 9.28428 0.558409 9.14237 0.557298 8.99902C0.558409 8.85567 0.586419 8.71377 0.639915 8.58045C0.639915 8.52232 0.639914 8.48744 0.722531 8.4293C0.753547 8.36868 0.78905 8.31039 0.828752 8.2549L6.72992 1.27878C6.84088 1.14754 6.97985 1.04199 7.13692 0.969642C7.29399 0.897298 7.46531 0.859939 7.6387 0.860217C7.91446 0.859685 8.18171 0.954297 8.39404 1.12763C8.51355 1.22524 8.61234 1.34512 8.68475 1.48039C8.75716 1.61567 8.80177 1.76368 8.81602 1.91597C8.83027 2.06825 8.81389 2.22181 8.76781 2.36785C8.72173 2.51389 8.64685 2.64953 8.54747 2.76702L4.26323 7.83633L18.2608 7.83634C18.5738 7.83634 18.874 7.95883 19.0953 8.17688C19.3167 8.39493 19.441 8.69066 19.441 8.99902C19.441 9.30739 19.3167 9.60312 19.0953 9.82117C18.874 10.0392 18.5738 10.1617 18.2608 10.1617Z"
      fill={fill}
    />
  </svg>
);

export default IconArrowLeft;
